// src/layouts/RootLayout.jsx
import { Flex, Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Analytics from '../components/Analytics';
import Seo from '../components/Seo';

const RootLayout = () => {
  return (
    <Flex direction="column" minH="100vh" bg="gray.50">
      <Seo />
      <Analytics />
      <Header />
      <Box as="main" flex="1" pt="16">
        <Outlet />
      </Box>
      <Footer />
    </Flex>
  );
};

export default RootLayout;
